import { css } from "@/root/stitches.config";

import JFestLogo from "@/assets/logo.svg";

import { Text } from "@/components/text";

export default function FooterBio() {
    return (
        <section
            className={css({
                display: "flex",
                flexDirection: "column",
                gridColumn: "1 / 6",
                gap: "2rem",
                zIndex: 2,
                "@tablet": { gridColumn: "1 / -1" },
                "@mobile": { gridColumn: "1 / -1" },
            }).toString()}
        >
            <div
                className={css({
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    height: "fit-content",
                    width: "fit-content",
                    gap: "1.5rem",
                    overflow: "hidden",
                }).toString()}
            >
                <img
                    src={JFestLogo}
                    alt="JFest Logo"
                    className={css({
                        width: 120,
                        pointerEvent: "none",
                        "@mobile": {
                            width: 80,
                            marginTop: "1rem",
                            marginBottom: "-1rem",
                            marginLeft: "-1rem",
                        },
                    }).toString()}
                />
            </div>

            <Text
                css={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                    fontSize: "0.95rem",
                    lineHeight: "1.75",
                    maxWidth: "500px",
                    paddingLeft: "1.5rem",
                    "@mobile": {
                        paddingLeft: "0rem",
                    },
                }}
            >
                <span>
                    JFEST is organized by the Japanese Community of STIKOM Bali (JCOS)
                    and supported by the Institute of Technology and Business (ITB) STIKOM Bali.
                    As the only campus-based festival dedicated to promoting Japanese culture,
                    JFEST is regularly attended by the Consulate General of Japan in Denpasar.
                </span>

                <span>
                    Through this festival, we aim to introduce and celebrate Japanese culture 
                    in a fun and engaging way, bringing together people from both the campus 
                    and the wider community.
                </span>
            </Text>
        </section>
    );
}